import { render, staticRenderFns } from "./courseAdd.vue?vue&type=template&id=28bca72c&"
import script from "./courseAdd.vue?vue&type=script&lang=js&"
export * from "./courseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports